// -----------------
// STATE - This defines the type of data maintained in the Redux store.
export class PermissionsObject {
    create?: boolean;
    read?: boolean;
    update?: boolean;
}

export class Permissions {
    duct: PermissionsObject;
    invoices: PermissionsObject;
    news: PermissionsObject;
    opportunities: PermissionsObject;
    orders: PermissionsObject;
    quickTickOnline: PermissionsObject;
    resourceTraining: PermissionsObject;
    fullAccess: PermissionsObject;
    qfv: PermissionsObject;
}

export class CustomerData {
    salesCurentYearToDate?: number;
    salesPreviousYearToDate?: number;
    salesPreviousYear?: number;
    ranking?: number;
    territoryName?: string;
}

export class UserState {
    permissions: Permissions;
    firstName?: string;
    lastName?: string;
    token: string;
    name?: string;
    contactEmailAddress?: string;
    crmUserId?: string;
    error?: boolean;
    errorMessage?: string;
    CustomerInformation: CustomerData;
}


// WEBPACK FOOTER //
// ./src/data/user/userModels.ts